import {BigNumber} from 'ethers';
import {parseUnits} from 'ethers/lib/utils';
import {omit} from 'lodash';
import {useCallback} from 'react';
import {useFormContext} from 'react-hook-form';
import {chainIdToNetworkName} from '../../lib/chains';
import {formatBigNumber, isSameAddress} from '../../lib/utilities';
import {useInvestMutation} from '../../redux/gft-root.api';
import {useCreateInvestMutation, useGetNetworksQuery} from '../../redux/projects.api';
import {selectWallet} from '../../redux/wallet.slice';
import {useAppSelector} from '../hooks';
import useProjectById from './useProjectById';
import useReferralCode from './useReferralCode';

const useInvestSubmit = (projectId: string) => {
  const {chainId} = useAppSelector(selectWallet);
  const {referralCode} = useReferralCode();
  const {data: networks} = useGetNetworksQuery();
  const projectData = useProjectById(projectId);
  const {reset, handleSubmit} = useFormContext();

  const [invest] = useInvestMutation();
  const [createInvest] = useCreateInvestMutation();
  const onSubmit = useCallback(
    async (data: any) => {
      try {
        const network = networks?.find(el => el.symbol === chainIdToNetworkName[chainId]);
        const formatted = formatBigNumber(BigNumber.from(projectData.project?.defaultAmount));
        const token = projectData.tokens?.find(el => isSameAddress(el.address || '0x', data.token));
        if (!token || !token.address) return new Error('Invest error');
        const createInvestRequest: any = omit(
          {
            projectId,
            createdAt: new Date().getTime(),
            networkId: network?.id,
            referralCode: referralCode || undefined,
            ...data,
            telegram: data.telegram || 'EMPTY',
          },
          ['amount', 'token'],
        );
        const investData = await createInvest(createInvestRequest).unwrap();
        await invest([investData.id!, projectId, token.address, parseUnits(data.amount, token?.decimals)]).unwrap();
        reset({
          amount: formatted,
        });
        // redirect && history.goBack();
      } catch (err) {
        console.error('Error on submit', err);
        throw err;
      }
    },
    [chainId, createInvest, invest, networks, projectData, projectId, referralCode, reset],
  );

  return {
    onSubmit: handleSubmit(onSubmit),
  };
};

export default useInvestSubmit;
